var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDivider = function SvgDivider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 121
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Ico/BulletStar/Single",
    d: "M5.332 66.9h-.109a8.756 8.756 0 00-2.643-4.665A5.316 5.316 0 000 60.742v-.084a5.641 5.641 0 002.822-1.23A6.4 6.4 0 005.223 54.5h.109a6.214 6.214 0 002.361 4.86 5.877 5.877 0 002.863 1.3v.085a5.321 5.321 0 00-2.58 1.492A8.759 8.759 0 005.332 66.9zm-.05-.612l-.009.03v.474-.5z",
    fill: "#ec6c68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 5",
    d: "M5.5.5v48",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 5 Copy",
    d: "M5.5 72.5v48",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  })));
};

export default SvgDivider;